if (!customElements.get('mue-hero-slider')) {
  class MueHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-mue-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-mue-hero-dot]'));
      this.previousButton = this.querySelector('[data-mue-hero-previous]');
      this.nextButton = this.querySelector('[data-mue-hero-next]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length < 2) return;

      this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true)));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.handleVisibility = () => (document.hidden ? this.stop() : this.start());
      this.handleBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const selectedSlide = event.target.closest('[data-mue-hero-slide]');
        if (!selectedSlide) return;
        this.goTo(this.slides.indexOf(selectedSlide), true);
      };

      document.addEventListener('visibilitychange', this.handleVisibility);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.goTo(this.currentIndex, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibility);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    goTo(index, restart) {
      const total = this.slides.length;
      this.currentIndex = (index + total) % total;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (restart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.reducedMotion || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.goTo(this.currentIndex + 1, false), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('mue-hero-slider', MueHeroSlider);
}
